export default function Alert({ isVisible, children }) {
  return isVisible ? <div className="alert-wrapper">{children}</div> : null;
}
